/**
 * A function to return the full political party name based on a letter abbreviation
 * @param {string} party - The party abbreviation (R, D, or I)
 * @returns {string} - The party name
 */
export default function getPartyName(party) {
  switch (party) {
    case 'R':
      return 'Republican';
    case 'D':
      return 'Democrat';
    case 'I':
      return 'Independent';
    default:
      return '--';
  }
}
